module.exports = __webpack_public_path__ + "static/media/SSS_Registeration_Form_2.5f3bcf27.pdf";